import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { T, t } from '@sm/intl';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { IconCheckCircle, IconFlag } from '@wds/icons';
export const COPY = {
  title: {
    id: 'OpenEndedCoding.KeywordsInfo.title',
    defaultMessage: 'What are the keywords?',
    description: '[Type: Header][Vis: med] - selecting keywords title'
  },
  description: {
    id: 'OpenEndedCoding.KeywordsInfo.description',
    defaultMessage: 'Keywords are the unique words associated with a theme. Our model identifies keywords based on theme name and response text, which makes tagging more accurate.',
    description: '[Type: Header][Vis: med] - selecting keywords description'
  },
  descriptionTaggedManually: {
    id: 'OpenEndedCoding.KeywordsInfo.descriptionTaggedManually',
    defaultMessage: 'The keywords shown here are based on the responses you tagged manually.',
    description: '[Type: Header][Vis: med] - selecting keywords description tagged manually'
  },
  do: {
    id: 'OpenEndedCoding.KeywordsInfo.do',
    defaultMessage: 'Do',
    description: '[Type: Header][Vis: med] - selecting keywords title do'
  },
  firstDo: {
    id: 'OpenEndedCoding.KeywordsInfo.firstDo',
    defaultMessage: 'Keep at least one keyword per theme.',
    description: '[Type: Header][Vis: med] - selecting keywords first do'
  },
  secondDo: {
    id: 'OpenEndedCoding.KeywordsInfo.secondDo',
    defaultMessage: 'Make sure each keyword is unique to a single theme.',
    description: '[Type: Header][Vis: med] - selecting keywords second do'
  },
  dont: {
    id: 'OpenEndedCoding.KeywordsInfo.dont',
    defaultMessage: "Don't",
    description: "[Type: Header][Vis: med] - selecting keywords title don't"
  },
  firstDont: {
    id: 'OpenEndedCoding.KeywordsInfo.firstDont',
    defaultMessage: 'Use the same keyword for multiple themes. Overlapping keywords might mean some themes are too similar. You can remove or merge redundant themes on the responses page.',
    description: '[Type: Header][Vis: med] - selecting keywords first dont'
  },
  secondDont: {
    id: 'OpenEndedCoding.KeywordsInfo.secondDont',
    defaultMessage: 'Add generic keywords that don’t appear in the responses.',
    description: '[Type: Header][Vis: med] - selecting keywords second dont'
  },
  iconCheckCircle: {
    id: 'OpenEndedCoding.KeywordsInfo.iconCheckCircle',
    defaultMessage: 'Check icon',
    description: '[Type: Label][Vis: low] - check icon'
  },
  iconFlag: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.iconFlag',
    defaultMessage: 'Flag icon',
    description: '[Type: Label][Vis: low] - flag icon'
  }
};
const useStyles = createUseStyles(theme => {
  return {
    list: {
      listStyleType: 'none',
      padding: 0,
      margin: `0 0 ${theme.spacing[3]}px 0`
    },
    item: {
      display: 'flex',
      marginBottom: theme.spacing[2]
    }
  };
});
const InfoItem = ({
  text,
  positive = false
}) => {
  const classes = useStyles();
  return _jsxs("li", {
    className: classes.item,
    children: [_jsx(Box, {
      pr: 2,
      children: positive ? _jsx(IconCheckCircle, {
        title: t(COPY.iconCheckCircle),
        color: "primary"
      }) : _jsx(IconFlag, {
        title: t(COPY.iconFlag),
        color: "warning"
      })
    }), _jsx(Typography, {
      component: "span",
      variant: "bodySm",
      children: _jsx(T, {
        desc: text
      })
    })]
  });
};
const KeywordsInfo = () => {
  const classes = useStyles();
  return _jsxs(Box, {
    ml: 6,
    display: "flex",
    flexDirection: "column",
    children: [_jsx(Box, {
      mb: 3,
      children: _jsx(Typography, {
        component: "h4",
        children: _jsx("strong", {
          children: _jsx(T, {
            desc: COPY.title
          })
        })
      })
    }), _jsx(Box, {
      mb: 4,
      children: _jsx(Typography, {
        component: "span",
        variant: "bodySm",
        children: _jsx(T, {
          desc: COPY.description
        })
      })
    }), _jsx(Box, {
      mb: 3,
      children: _jsx(Typography, {
        component: "span",
        variant: "bodySm",
        children: _jsx(T, {
          desc: COPY.descriptionTaggedManually
        })
      })
    }), _jsx(Box, {
      mb: 3,
      children: _jsx(Typography, {
        component: "h4",
        children: _jsx("strong", {
          children: _jsx(T, {
            desc: COPY.do
          })
        })
      })
    }), _jsxs("ul", {
      className: classes.list,
      children: [_jsx(InfoItem, {
        text: COPY.firstDo,
        positive: true
      }), _jsx(InfoItem, {
        text: COPY.secondDo,
        positive: true
      })]
    }), _jsx(Box, {
      mb: 3,
      children: _jsx(Typography, {
        component: "h4",
        children: _jsx("strong", {
          children: _jsx(T, {
            desc: COPY.dont
          })
        })
      })
    }), _jsxs("ul", {
      className: classes.list,
      children: [_jsx(InfoItem, {
        text: COPY.firstDont
      }), _jsx(InfoItem, {
        text: COPY.secondDont
      })]
    })]
  });
};
export default KeywordsInfo;